import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseDeviceType } from '@app/models/disciplinemanagement/base-device-type.model';
import { DeviceTypeExtended } from '@app/models/disciplinemanagement/device-type-extended.model';
import { DeviceType } from '@app/models/disciplinemanagement/device-type.model';
import { Device } from '@app/models/disciplinemanagement/device.model';
import { DisciplineColourGroup } from '@app/models/disciplinemanagement/discipline-colour-group.model';
import { DisciplineExtended } from '@app/models/disciplinemanagement/discipline-extended.model';
import { Section } from '@app/models/disciplinemanagement/section.model';
import { Discipline } from '@app/models/dna/dna.discipline.model';

@Injectable({
  providedIn: 'root'
})
export class DisciplineManagementService {

  private service = "disciplineManagementService";

  constructor(private http: HttpClient) { }

  public getDisciplinesWithActive(isActive: boolean) {
    return this.http.get<DisciplineExtended[]>(
      `api/${this.service}/getDisciplines?isActive=${isActive}`,
      {
        responseType: "json",
      }
    );
  }

  public listDisciplines() {
    return this.http.get<Discipline[]>(
      `api/${this.service}/listDisciplines`,
      {
        responseType: "json",
      }
    );
  }

  public getDisciplines() {
    return this.http.get<DisciplineExtended[]>(
      `api/${this.service}/getDisciplines`,
      {
        responseType: "json",
      }
    );
  }

  public getSections() {
    return this.http.get<Section[]>(
      `api/${this.service}/getSections`,
      {
        responseType: "json",
      }
    );
  }

  public getBaseDeviceTypes() {
    return this.http.get<BaseDeviceType[]>(
      `api/${this.service}/getBaseDeviceTypes`,
      {
        responseType: "json",
      }
    );
  }

  public getDiscipline(id: number) {
    return this.http.get<DisciplineExtended>(
      `api/${this.service}/getDiscipline/${id}`,
      {
        responseType: "json",
      }
    );
  }

  public getDisciplineDeviceTypes(id: number, sectionId: number) {
    return this.http.get<DisciplineExtended>(
      `api/${this.service}/getDisciplineDeviceTypes/${id}/${sectionId}`,
      {
        responseType: "json",
      }
    );
  }

  public getDeviceType(disciplineId: number, sectionId: number, deviceTypeId: number) {
    return this.http.get<DisciplineExtended>(
      `api/${this.service}/getDeviceType/${disciplineId}/${sectionId}/${deviceTypeId}`,
      {
        responseType: "json",
      }
    );
  }

  public getDisciplineDesignAssistantSettings(id: number) {
    return this.http.get<DisciplineExtended>(
      `api/${this.service}/getDisciplineDesignAssistantSettings/${id}`,
      {
        responseType: "json",
      }
    );
  }

  public getDisciplineSystemTypes(discipline: DisciplineExtended) {
    return this.http.post<DisciplineExtended>(
      `api/${this.service}/getDisciplineSystemTypes`,
      discipline,
      {
        responseType: "json",
      }
    );
  }

  public getDisciplineFunctions(id: number) {
    return this.http.get<DisciplineExtended>(
      `api/${this.service}/getDisciplineFunctions/${id}`,
      {
        responseType: "json",
      }
    );
  }

  public getDisciplineColourDefinitions() {
    return this.http.get<DisciplineColourGroup[]>(
      `api/${this.service}/getDisciplineColourDefinitions`,
      {
        responseType: "json",
      }
    );
  }

  public saveDiscipline(discipline: DisciplineExtended) {
    return this.http.post<DisciplineExtended>(`api/${this.service}/saveDiscipline`, discipline, {
      responseType: "json",
    });
  }

  public saveDisciplineDesignMenu(discipline: DisciplineExtended) {
    return this.http.post<DisciplineExtended>(`api/${this.service}/saveDisciplineDesignMenu`, discipline, {
      responseType: "json",
    });
  }

  public saveDisciplineDesignIcon(discipline: DisciplineExtended) {
    return this.http.post<DisciplineExtended>(`api/${this.service}/saveDisciplineDesignIcon`, discipline, {
      responseType: "json",
    });
  }

  public saveDisciplineColourDefinition(discipline: DisciplineExtended) {
    return this.http.post<DisciplineExtended>(`api/${this.service}/saveDisciplineColourDefinition`, discipline, {
      responseType: "json",
    });
  }

  public saveDisciplineScaleSetting(discipline: DisciplineExtended) {
    return this.http.post<DisciplineExtended>(`api/${this.service}/saveDisciplineScaleSetting`, discipline, {
      responseType: "json",
    });
  }

  public saveDisciplineTemplateNaming(discipline: DisciplineExtended) {
    return this.http.post<DisciplineExtended>(`api/${this.service}/saveDisciplineTemplateNaming`, discipline, {
      responseType: "json",
    });
  }

  public saveDeviceType(deviceType: DeviceType) {
    return this.http.post<DisciplineExtended>(`api/${this.service}/saveDeviceType`, deviceType, {
      responseType: "json",
    });
  }

  public saveDeviceTypeTag(deviceType: DeviceTypeExtended) {
    return this.http.post<DisciplineExtended>(`api/${this.service}/saveDeviceTypeTag`, deviceType, {
      responseType: "json",
    });
  }

  public saveDisciplineDevice(device: Device) {
    return this.http.post<DisciplineExtended>(`api/${this.service}/saveDisciplineDevice`, device, {
      responseType: "json",
    });
  }
}
